export default {
  auditLogsList: [],
  auditLogsList_all: [],
};
